export default __webpack_public_path__ + "static/media/discounts-happy-hour-image.546224a0.svg";